import { action, makeObservable, observable } from 'mobx';
import { ICatalogsUnitItem, ISelect } from '../interfaces';

export class CatalogsStore {
    private constructor() {
        makeObservable(this);
    }

    private static instance: CatalogsStore;
    public static getInstance(): CatalogsStore {
        if (!CatalogsStore.instance) {
            CatalogsStore.instance = new CatalogsStore();
        }
        return CatalogsStore.instance;
    }

    @observable rateUnitTypeSelect: ICatalogsUnitItem[] = [];
    @action setRateUnitTypeSelect(list: ICatalogsUnitItem[]): void {
        this.rateUnitTypeSelect = list;
    }
    initOriginalUnitTypeList: ISelect[] = [
        { id: 'byte', name: 'Data' },
        { id: 'sms', name: 'SMS' },
        { id: 'sec', name: 'Voice' },
    ];
    @observable originalUnitTypeSelect: ISelect[] = this.initOriginalUnitTypeList;
    @action setOriginalUnitTypeSelect(list: ISelect[]): void {
        this.originalUnitTypeSelect = list;
    }
    @observable dataUnitTypeSelect: ISelect[] = [];
    @action setDataUnitTypeSelect(list: ISelect[]): void {
        this.dataUnitTypeSelect = list;
    }
    @observable importTypeSelect: ISelect[] = [];
    @action setImportTypeSelect(list: ISelect[]): void {
        this.importTypeSelect = list;
    }
    @observable companyTypes: ISelect[] = [];
    @action setCompanyTypes(list: ISelect[]): void {
        this.companyTypes = list;
    }

    @observable paymentTypes: ISelect[] = [];
    @action setPaymentTypes(list: ISelect[]): void {
        this.paymentTypes = list;
    }
    @observable productTypes: ISelect[] = [];
    @action setProductTypes(list: ISelect[]): void {
        this.productTypes = list;
    }

    @action cleanStore(): void {
        this.companyTypes = [];
        this.dataUnitTypeSelect = [];
        this.importTypeSelect = [];
        this.originalUnitTypeSelect = this.initOriginalUnitTypeList;
        this.paymentTypes = [];
        this.productTypes = [];
        this.rateUnitTypeSelect = [];
    }
}
